import { BaseModel } from '../_base/model.class';

import { IContractor, IReceivedDocument, ITaxDeductionFee } from './intervention.interface';



export class Intervention extends BaseModel {
  constructor(
    private _id?: string,
    private name?: string,
    private propertyName?: string,
    private type?: string,
    private status?: string,
    private totalFee?: number,
    private meetingResolutionDate?: Date,
    private contractors?: [IContractor],
    private constructionManagement?: string,
    private securityCoordinator?: string,
    private constructionStart?: Date,
    private constructionEnd?: Date,
    private taxDeductionType?: string,
    private taxDeductionFees?: [ITaxDeductionFee],
    private notes?: string,
    private receivedDocuments?: [IReceivedDocument],
    private createdBy?: string,
    private createdAt?: Date,
    private updatedBy?: string,
    private updatedAt?: Date,
  ) {
    super();

    this.setRequiredFields([
      '_id',
      'name',
      'createdAt',
      'createdBy',
    ]);
  }
}
